//@ts-check
import React, { PureComponent, lazy, Suspense } from 'react';
import { Provider, connect } from 'react-redux';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';
import store from './redux/store';
import Login from './views/account/login/login';
import appAction from './redux/actions/appAction';
import PageLoading from './components/loading/page-loading/page-loading';
import './App.scss';
import AddLicense from './views/administration/licenses/component/add-license/add-license';
import PasswordReset from './views/account/change-password/change-password';
import antd_enUS from 'antd/es/locale/en_US';

import localENUS from 'en-US';
import { IntlProvider } from 'react-intl';
import { ConfigProvider } from 'antd';


const AdminPage = lazy(() =>
    import(/* webpackChunkName: "admin_module" */ './module/admin/page')
);
const ForgotPassword = lazy(() =>
    import(
        /* webpackChunkName: "forgot-password" */ './views/account/forgot-password/forgot-password'
    )
);
const ResetPassword = lazy(() =>
    import(
        /* webpackChunkName: "reset-password" */ './views/account/reset-password/reset-password'
    )
);
const ChangeTempPassword = lazy(() =>
    import(
        './views/account/change-temp-password/change-temp-password'
    )
);

const PrivacyPolicy = lazy(() =>
    import(
        /* webpackChunkName: "privacy-policy" */ './views/web-site/privacy-policy'
    )
);
const TermsAndConditions = lazy(() =>
    import(
        /* webpackChunkName: "terms-and-conditions" */ './views/web-site/terms-and-conditions'
    )
);

const Signup = lazy(() =>
    import(/* webpackChunkName: "sign-up" */ './views/account/sign-up/sign-up')
);

export default function App() {
    return (
        <Provider store={store}>
            <Router>
                <Container />
            </Router>
        </Provider>
    );
}

function mapStateToProps(state) {
    return {
        init: state.app.init,
        account: state.account.current,
        isLogin: state.account.isLogin,
        language: 'en-US',
        languageTexts: state.app.languageTexts
    };
}

const Container = connect(mapStateToProps)(
    class extends PureComponent {
        state = {
            languageSource: {
                'en-US': {},
            },
            languageTexts: {
                'en-US': localENUS,
            }
        };
        async componentDidMount() {
            const { init, dispatch } = this.props;

            try {
                // Simulate fetching translations (uncomment if needed)
                // const languageTexts = await pagestatic.getlanguagebycode() || {};
                // this.setState({ languageTexts });

                // Ensure languageSource is initialized properly
                this.setState(
                    {
                        languageSource: {
                            'en-US': localENUS,
                        }
                    }
                );
            } catch (error) {
                console.error("⚠️ Error setting languageTexts:", error);
            }

            if (!init) {
                await dispatch(appAction.init());
            }

            // Listen for organization change from other tabs and reload if mismatched
            try {
                if ('BroadcastChannel' in window) {
                    const channel = new BroadcastChannel('amie-session');
                    channel.onmessage = (ev) => {
                        if (ev && ev.data && ev.data.type === 'org-changed') {
                            const newOrg = ev.data.organizationId || '';
                            const curOrg = sessionStorage.getItem('CURRENT_ORGANIZATION') ? decodeURIComponent(sessionStorage.getItem('CURRENT_ORGANIZATION')) : '';
                            if (newOrg && newOrg !== curOrg) {
                                // Use existing flow to sync this tab; reload will be handled inside action when fromBroadcast is true
                                this.props.dispatch(appAction.setCurrentOrganization(newOrg, { fromBroadcast: true }));
                            }
                        }
                    };
                    this._amieChannel = channel;
                }
            } catch (e) {
                console.error("Error:", e);
            }
        }

        componentDidUpdate() { }

        componentWillUnmount() {
            try {
                if (this._amieChannel) {
                    this._amieChannel.close();
                }
            } catch (e) {}
        }

        render() {
            const { init, isLogin } = this.props;

            if (!init) {
                return <PageLoading />;
            }
            const antdLocal = antd_enUS;
            const appLocal = this.state.languageSource['en-US'];

            return (
                <IntlProvider locale={this.props.language} messages={appLocal}>
                    <ConfigProvider locale={antdLocal}>
                        <Suspense fallback={<PageLoading />}>
                            <Switch>
                                <Route path="/login" exact component={Login} />
                                <Route
                                    path="/forgot-password"
                                    exact
                                    component={ForgotPassword}
                                />
                                <Route
                                    path="/reset-password" //take a code
                                    component={ResetPassword}
                                />
                                <Route
                                    path="/change-password" //change old password
                                    component={PasswordReset}
                                />
                                <Route
                                    path="/change-temp-password" //change temp password
                                    component={ChangeTempPassword}
                                />
                                <Route
                                    path="/privacy-policy"
                                    exact
                                    component={PrivacyPolicy}
                                />
                                <Route
                                    path="/terms-and-conditions"
                                    exact
                                    component={TermsAndConditions}
                                />
                                <Route
                                    path="/terms-of-use"
                                    exact
                                    component={TermsAndConditions}
                                />

                                <Route path="/signup" component={Signup} />

                                <Route
                                    path="/add-license"
                                    render={(props) => {
                                        if (!isLogin) {
                                            return <Redirect to="/login" />;
                                        }
                                        return <AddLicense {...props} />;
                                    }}
                                />

                                <Route
                                    path="/"
                                    render={(props) => {

                                        if (!isLogin) {
                                            return <Redirect to="/login" />;
                                        }
                                        return <AdminPage {...props} />;
                                    }}
                                />
                            </Switch>
                        </Suspense>
                    </ConfigProvider>
                </IntlProvider>
            );
        }
    }
);